/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import { toast } from 'react-toastify';

import { SectionCanva } from '@mairistem/administres-utils';

import { useDocumentStore } from '@/zustand';
import {
  fileToPreviewImages,
  type PreviewImage,
} from '@/utils/documentPreview';

const AssistantApercuDocument = () => {
  const document = useDocumentStore((state) => state.document);

  const [images, setImages] = React.useState<PreviewImage[]>([]);
  const [selectedIndex, setSelectedIndex] = React.useState<number>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!document) {
      setImages([]);
      return undefined;
    }

    let alive = true;
    setIsLoading(true);
    setSelectedIndex(0);

    fileToPreviewImages(document)
      .then((previewImages) => {
        if (alive) {
          setImages(previewImages);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(
          "Erreur lors de la génération de l'aperçu du document",
          error,
        );
        if (alive) {
          setImages([]);
          toast("Erreur lors de l'affichage du document", { type: 'error' });
        }
      })
      .finally(() => {
        if (alive) {
          setIsLoading(false);
        }
      });

    return () => {
      alive = false;
    };
  }, [document]);

  const handlePrint = React.useCallback(() => {
    if (document) {
      window.open(URL.createObjectURL(document), '_blank');
    }
  }, [document]);

  return (
    <SectionCanva
      images={images}
      selectedIndex={selectedIndex}
      onImageChange={setSelectedIndex}
      onPrint={handlePrint}
      isLoading={isLoading}
      fitMode="width"
      style={{
        height: '100%',
        border: '1px solid #ccc',
        borderRadius: '4px',
      }}
    />
  );
};

export default AssistantApercuDocument;
